import { Icon } from "@coverme/icons";
import * as PropTypes from "prop-types";
import React from "react";

export function MiniFacesheetPersonal(props) {
    return (
        <>
            <div className="mini-facesheet__info-item">
                <span className="p-regular">
                    <span className="h5">Phone </span>
                    {props.entry.patient.primaryPhoneNumber?.phoneNumber
                        ?.replace(/\D+/g, "")
                        ?.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3")}
                </span>
            </div>
            <div className="mini-facesheet__info-item">
                <span className="p-regular">
                    <span className="h5">Language </span>
                    <span className="p-regular">{props.entry.patient.preferredLanguage}</span>
                </span>
            </div>
            <div className="mini-facesheet__info-item">
                <span className="p-regular">
                    <span className="h5">Marital Status </span>
                    <span className="p-regular">{props.entry.patient.maritalStatus}</span>
                </span>
            </div>
            <div className="mini-facesheet__info-item">
                <span className="p-regular">
                    <span className="h5">Citizenship </span>
                    <span className="p-regular">
                        {props.entry.patient.isUsCitizen ? "US Citizen" : "Non US Citizen"}
                    </span>
                </span>
            </div>

            {!props.entry.patient.isUsCitizen && (
                <div className="mini-facesheet__info-item">
                    <span className="p-regular">
                        <span className="h5">Immigration Status </span>
                        <span className="p-regular">{props.entry.patient.immigrationStatus}</span>
                    </span>
                </div>
            )}
            <div className="mini-facesheet__info-item">
                <span className="p-regular">
                    <span className="h5">Address </span>
                    {`${props.entry.patient.address.city}, ${props.entry.patient.address.state}, ${
                        props.entry.patient.address.zipCode
                    }`}
                </span>
            </div>
        </>
    );
}

MiniFacesheetPersonal.propTypes = {
    personalOpen: PropTypes.any,
    onClick: PropTypes.func,
    entry: PropTypes.any,
};
